export const LEGAL_TOOLS_ROADMAP = {
  preparedFeatures: [
    "reply-letter-generator",
    "firm-mode-prefill",
    "office-templates",
    "subscription-gating",
  ],
  notes: [
    "التنفيذ الحالي مستقل ويعمل بدون الاعتماد على Firm Mode.",
    "يمكن لاحقاً تمرير initialValues لأي أداة عند توفر بيانات المكتب.",
    "يمكن إضافة بوابة اشتراكات قبل submit tool action عبر wrapper واحد.",
  ],
};

